<ng-dialog-header [title]="title"></ng-dialog-header>
<mat-dialog-content>
  <ns-grid class="h-100"
           [name]="gridConfigurations.gridName"
           [columns]="gridConfigurations.columns"
           [data]="comments"
           [loading]="loading"
           [gridOptions]="gridConfigurations.options"
           [config]="gridConfigurations.headerOptions">
  </ns-grid>
</mat-dialog-content>
<ng-dialog-footer>
  <div dialog-actions class="d-flex justify-content-end w-100">
    <button mat-stroked-button color="warn" aria-label="close" mat-dialog-close>Close</button>
  </div>
</ng-dialog-footer>
